document.addEventListener('DOMContentLoaded', () => {
   // dropdownUsuario
    const contHeaderUsuario = document.querySelector(".contHeaderUsuario");
    if(!contHeaderUsuario) return;

    // mostrar cuando el mouse entra
    contHeaderUsuario.addEventListener("click", () => {
    contHeaderUsuario.classList.add("active");
    });

    // ocultar cuando el mouse sale
    contHeaderUsuario.addEventListener("mouseleave", () => {
    contHeaderUsuario.classList.remove("active");
    });
    
    /////////
    //MENU HAMBURGEUSA
    const containerMenu = document.querySelector('#PanelAcciones');
    const botonMenuHbg = document.querySelector('#botonMenuHbg');
    const botonMenuX = document.querySelector('#botonMenuX');

    if(botonMenuHbg){
        botonMenuHbg.addEventListener('click', () => {
            containerMenu.classList.toggle('mostrar');
            document.body.classList.toggle('menuAbierto');
            botonMenuX.classList.remove('btnMenuOcultar');
            botonMenuX.classList.toggle('btnMenuMostrar');
            botonMenuHbg.classList.toggle('btnMenuOcultar');
        });
    }
    if(botonMenuX){
        botonMenuX.addEventListener('click', () => {
            containerMenu.classList.toggle('mostrar');
            document.body.classList.toggle('menuAbierto');
            botonMenuHbg.classList.remove('btnMenuOcultar');
            botonMenuHbg.classList.toggle('btnMenuMostrar');
            botonMenuX.classList.toggle('btnMenuOcultar');
        });
    }

    document.addEventListener('input', function (e) {
        const input = e.target.closest('.formatoNumero');
        if (!input) return;
        let valorInput = input.value.replace(/\D/g, '');
        if (valorInput === "") {
            input.value = "";
            return;
        }
        const numberFormat = new Intl.NumberFormat('en-US'); 
        const valorFormateado = numberFormat.format(valorInput);
        input.value = valorFormateado;
    });
    document.addEventListener('input', function (e) {
    const input = e.target.closest('.formatoNumeroDecimal');
        if (!input) return;

        // 1. Limpiar el valor: permitir solo números y un punto decimal
        let valor = input.value.replace(/[^0-9.]/g, '');

        // 2. Evitar múltiples puntos decimales
        const partes = valor.split('.');
        if (partes.length > 2) {
            valor = partes[0] + '.' + partes.slice(1).join('');
        }

        // 3. Limitar a 2 decimales
        if (partes[1] && partes[1].length > 2) {
            valor = partes[0] + '.' + partes[1].slice(0, 2);
        }

        if (valor === "") {
            input.value = "";
            return;
        }

        // 4. Formatear la parte entera con Intl.NumberFormat
        const parteEntera = valor.split('.')[0];
        const tienePunto = valor.includes('.');
        const parteDecimal = valor.split('.')[1];

        const formatter = new Intl.NumberFormat('en-US');
        let valorFormateado = formatter.format(parteEntera);

        // 5. Reconstruir el string para permitir que el usuario siga escribiendo
        // Si hay un punto, lo añadimos manualmente al final del formato
        if (tienePunto) {
            valorFormateado += "." + (parteDecimal || "");
        }

        input.value = valorFormateado;
    });

    //Borrar inputRojo cuando se corrije el error.
    document.addEventListener('input', limpiarInputRojo);
    document.addEventListener('change', limpiarInputRojo);
    document.addEventListener('click', limpiarInputRojo);
    document.addEventListener('blur', limpiarInputRojo);

    function limpiarInputRojo(e) {

        const campo = e.target.closest('input, select, textarea, article');

        if (!campo) return;

        if (campo.classList.contains('inputRojo')) {
            campo.classList.remove('inputRojo');
        }
    }



});